export default {
  populate: {
    facility_type: {
      fields: "id",
      populate: {
        localizations: {
          fields: ["id", "locale"],
        },
      },
    },
    facility_category: {
      fields: "id",
      populate: {
        localizations: {
          fields: ["id", "locale"],
        },
      },
    },
    facility_services: {
      fields: "id",
      populate: {
        localizations: {
          fields: ["id", "locale"],
        },
      },
    },
    image: true,
    gallery: true,
    localizations: true,
  },
};
